import React, { Component, Fragment } from "react";
import { Table } from "antd";
import _ from "lodash";
import { assign, forEach } from "lodash/fp";
import { upsellUser } from "./userUpsell";
const columns = [
	{
		title: "ID Personne",
		dataIndex: "idPerson",
	},
	{
		title: "Prénon",
		dataIndex: "firstName",
	},
	{
		title: "Nom",
		dataIndex: "lastName",
	},
	{
		title: "E-mail",
		dataIndex: "email",
	},
];

class InsertElement extends Component {
	componentDidMount() {
		this.props.getAllUsers();
		// _.forEach(upsellUser, (user, index) => {
		// 	let transformUser = _.assign([], [user]);

		// 	let data = {
		// 		newUser: JSON.stringify(transformUser),
		// 	};

		// 	this.props.addElementMlab(data);
		// });
	}
	render() {
		const { userAddList } = this.props;
		return (
			<Fragment>
				<Table columns={columns} dataSource={userAddList} />
			</Fragment>
		);
	}
}

export default InsertElement;



// WEBPACK FOOTER //
// src/components/survey/insert/index.js